import { type JSX } from "react";

import { ThemedButton } from "../Buttons/ThemedButton";

import { ActionMenu, type ActionMenuProps, type MenuItem } from "./ActionMenu";

export type TableActionMenuItem = MenuItem & {
  icon: JSX.Element;
};

export type TableActionMenuProps = ActionMenuProps & {
  menuItems: TableActionMenuItem[];
};

export const TableActionMenu = (props: TableActionMenuProps) => {
  const { menuItems, dataTestId, disabled, className } = props;

  if (!menuItems.length) return null;

  if (menuItems.length === 1)
    return (
      <ThemedButton
        ariaLabel="Actions"
        className={className}
        dataTestId={
          dataTestId
            ? `table-${dataTestId}-action-menu-button`
            : "table-action-menu-button"
        }
        disabled={disabled}
        icon={menuItems[0].icon}
        onClick={(e) => {
          e.stopPropagation();
          menuItems[0].onClick();
        }}
        variant="tertiary"
      />
    );

  return <ActionMenu {...props} />;
};
